var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

/**
 * @constructor
 */
var KeyMovingStateMachine = function (root, movingModel, editorModel, moveCollection) {
    var self = this;

    this.root = root;
    this.model = movingModel;
    this.editorModel = editorModel;
    this.moveCollection = moveCollection;

    lib_core.StateMachine.call(this);

    this.movingKeyCodes = [];
    [ 'up', 'down', 'left', 'right'].forEach(function(value){
        self.movingKeyCodes.push(value);
        self.movingKeyCodes.push('S_' + value);
    }, self);

    this.timer = null;

    this.addTransition('idle', 'keyMoving',
        function (cEvent) {
            return (cEvent.isKeyPressed( self.movingKeyCodes) && self.moveCollection.size() > 0);
        },
        function (cEvent) {
            self.root.rec();

            self.model.onElementMovingStart();

            self.keyMove(cEvent.data('keyCode'), cEvent);
            self.resetTimer();
        }
    );

    this.addTransition("keyMoving","keyMoving",
        function(cEvent) {
            return (cEvent.isKeyPressed( self.movingKeyCodes) && self.moveCollection.size() > 0 );
        },
        function(cEvent) {
            self.keyMove(cEvent.data('keyCode'), cEvent);
            self.resetTimer();
        }
    );

    this.keyMovingStopTransition = this.addTransition("keyMoving", "idle",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.GUI_TIMER ||   // if timer ends or any other event (except for mouse_move or arrow keys) happens: end moving state
                    !(cEvent.isKeyPressed(self.movingKeyCodes) || cEvent.type().isHoverAction ));
        },
        function(cEvent){
            self.model.onElementMovingStop();
            self.root.stopRec();

            self.handle(cEvent); // reinject event
        }
    );
};
lib_core.inherit(KeyMovingStateMachine, lib_core.StateMachine);

module.exports = KeyMovingStateMachine;

KeyMovingStateMachine.prototype.cancelKeyMoving = function (cancel){
    this.snapModel.snap_info(null);
    this.model.onElementMovingStop();
    if (!cancel){
        this.root.stopRec();
    } else {
        this.root.cancelRec();
    }
};

KeyMovingStateMachine.prototype.keyMove = function(keyCode, cEvent)
{
    var parts = keyCode.split("_");
    var shift = '';
    var direction = parts[0];
    if (parts.length == 2) {
        shift = parts[0];
        direction = parts[1];
    }

    var stepSize = this.getStepSize();
    if (shift == 'S') {
        stepSize /= 10;
    }

    var vector;
    switch(direction) {
        case 'up':
            vector = new lib_geometry.Coord(0, 1 * stepSize);
            break;
        case 'down':
            vector = new lib_geometry.Coord(0, -1 * stepSize);
            break;
        case 'left':
            vector = new lib_geometry.Coord(-1 * stepSize, 0);
            break;
        case 'right':
            vector = new lib_geometry.Coord(1 * stepSize, 0);
            break;
        default:
            return;
    }

    var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};
    this.moveCollection.forEach(function(element) {
        element.move(vector, keys);
    });
};

KeyMovingStateMachine.prototype.getStepSize = function()
{
    if (this.editorModel.origin()) {
        return this.editorModel.origin().getGridSpacing();
    } else {
        return 10;
    }
};

KeyMovingStateMachine.prototype.resetTimer = function()
{
    if (this.timer) {
        window.clearTimeout(this.timer);
    }

    var self = this;
    this.timer = window.setTimeout(function(){
        self.handle(lib_core.GuiEvents.GUI_TIMER);
    }, 500);
};
